module.exports = __webpack_public_path__ + "static/typeform.261ace20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicare/typeform.png
// module id = 3722
// module chunks = 142354426033121